import React from 'react';
import {
    Container, Box, Table, TableBody,
    TableCell, TableContainer, TableHead,
    TableRow, Paper, Typography
} from '@mui/material';

const ValidationResponseComp = ({ data, success_count }) => {
    const showTableData = (
        <>
            <Container style={{
                display: 'flex', flexDirection: 'column', width: '85vh',
                justifyContent: 'center', alignItems: 'center', padding: '2rem',
                overflow: 'hidden'
            }}>
                <Box sx={{
                    width: '70vh', maxHeight: '50svh', overflow: 'auto',
                    padding: 2, border: '1px solid #ccc', borderRadius: '10px',
                }}>
                    <Typography variant='body2' sx={{ padding: 1 }}>Out of
                        <span style={{ color: 'red', fontSize: '18px' }}> {success_count + data.length} / {data.length} </span>
                        rows are invalid and will not be updated upon upload.
                    </Typography>
                    <TableContainer component={Paper}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontSize: '0.875rem' }} >Row Index</TableCell>
                                    <TableCell sx={{ fontSize: '0.875rem' }} >Username</TableCell>
                                    <TableCell sx={{ fontSize: '0.875rem' }} >Error Message</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row) => (
                                    <TableRow key={row.rowIndex}>
                                        <TableCell sx={{ fontSize: '0.875rem' }} >{row.rowIndex}</TableCell>
                                        <TableCell sx={{ fontSize: '0.875rem' }} >{row.username}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', color: 'red', padding: 1 }} >
                                            {row.errors.map((error, index) => (
                                                <div sx={{}} key={index}>{error}</div>
                                            ))}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Container>
        </>
    );
    const showNoError = (
        <>
            <Container style={{
                display: 'flex', flexDirection: 'column', width: '85vh',
                justifyContent: 'center', alignItems: 'center', padding: '2rem',
                overflow: 'hidden'
            }}>
                <Box sx={{
                    width: '70vh', maxHeight: '50svh', overflow: 'auto',
                    padding: 2, border: '1px solid #ccc', borderRadius: '10px',
                }}>
                    <Typography variant='body2' sx={{
                        padding: '2rem', color: 'green'
                    }}>Uploaded CSV file data are valid, Total {success_count} number of rows present.</Typography>
                </Box>
            </Container>
        </>
    )
    return (
        data.length > 0 ? showTableData : showNoError
    );
};

export default ValidationResponseComp;